import moment from 'moment-timezone';

const dateDifferenceInDays = (firstDate, secondDate) => {
  return Math.ceil(firstDate.diff(secondDate, 'days', true));
};

const countdownByPhase = (churchRevival, date, revivalPhase) => {
  switch(revivalPhase || churchRevival.phase) {
    case 0:
      return dateDifferenceInDays(moment.unix(churchRevival.preparationStartDate), moment(date).tz('UTC'));
    case 1:
      return dateDifferenceInDays(moment.unix(churchRevival.startDate), moment(date).tz('UTC'));
    case 2:
      return dateDifferenceInDays(moment.unix(churchRevival.endDate), moment(date).tz('UTC'));
    default:
      return null;
  }
};

export const revivalPhaseDay = (churchRevival) => {
  const currentDate = moment(new Date()).tz('UTC');

  switch(churchRevival.phase) {
    case 0:
      return dateDifferenceInDays(moment.unix(churchRevival.preparationStartDate), moment(currentDate));
    case 1:
      return dateDifferenceInDays(moment.unix(churchRevival.startDate), moment(currentDate));
    case 2:
      return churchRevival.phaseDayNumber === 0 ? 1 : churchRevival.phaseDayNumber;
    case 3:
      return dateDifferenceInDays(moment(currentDate), moment.unix(churchRevival.endDate));
    default:
      return 0;
  }
};

export const revivalPhaseCountdown = (churchRevival, date = new Date()) => {
  return countdownByPhase(churchRevival, date);
};

export const churchMemberRegistrationDateCountdown = (churchRevival, date = new Date(), revivalPhase) => {
  return countdownByPhase(churchRevival, date, revivalPhase);
};



// WEBPACK FOOTER //
// ./src/utilities/churchRevival.js